import List from 'semantic-ui-react/dist/commonjs/elements/List'
export default List
